import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import "bootstrap/dist/css/bootstrap.rtl.min.css"
import "bootstrap/dist/js/bootstrap.bundle.min.js"
import "bootstrap-icons/font/bootstrap-icons.css";
import './assets/style.css'

const app = createApp(App)

app.config.errorHandler = (err, vm, info) => {
    console.error('VUE ERROR HANDLER:', err, info);
    // You could theoretically show a toast here too
}

import vue3GoogleLogin from 'vue3-google-login';
const clientId = '618551900107-gu98tab1rocqh5cqj1sgcui7pmvt8qm6.apps.googleusercontent.com';

app.use(store).use(router).use(vue3GoogleLogin, {
    clientId: clientId,
    scope: 'email profile openid'
    // prompt removed to explicitly disable global auto-prompt One Tap
}).mount('#app')
